export default __webpack_public_path__ + "static/media/math-icon.597a5e945a1fcd73b25582647027509d.svg";